import ClassenService from '../ClassenService';

class ProductService {
  getProducts() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/products`);
  }

  addProduct(productData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/products`, 'addProduct', productData);
  }

  getProduct(productId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/products/${productId}`);
  }

  getBevelColors() {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/products/bevelColors`);
  }

  getProductQuickSelection(productId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/products/${productId}/quickselections`);
  }

  updateProduct(productId, productData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/products/${productId}`, 'updateProduct', productData);
  }

  deleteProduct(productId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/products/${productId}`, 'deleteProduct');
  }

  searchProducts(page = 1, size = 16, searchData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/products/search?page[size]=${size}&page[number]=${page}`, 'searchData', searchData);
  }

  addSearchProductsToSelection(searchData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/products/addSearchToSelection`, 'addAllToSelection', searchData);
  }

  removeSearchFromSelection(searchData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/products/removeSearchFromSelection`, 'removeSearchFromSelection', searchData);
  }

  getProductsFacets() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/products/facets`);
  }
}

export default new ProductService();
